import { render, staticRenderFns } from "./RevDoc.vue?vue&type=template&id=41f61212"
import script from "./RevDoc.vue?vue&type=script&lang=js"
export * from "./RevDoc.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./RevDoc.vue?vue&type=style&index=1&id=41f61212&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports